import React from "react";
import { Link } from "react-router-dom";
import { Box, Button, Paper, Typography } from "@mui/material";

const Logout = ({logout}) => {
	return (
		<Box
			className="argus-full-page-container argus-background"
			sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				py: 6
			}}
		>
			<Link to="/">
				<Box
					component="img"
					src="https://argusweb.azureedge.net/argus-web/logo.svg"
					alt="Argus"
					sx={{width: 300, maxWidth: "100%", mb: 4}}
				/>
			</Link>
			<Paper elevation={3} sx={{p: 4, width: "100%", maxWidth: 480, textAlign: "center"}}>
				<Typography variant="h5" component="h1" sx={{mb: 3}}>
					Are you sure you want to logout?
				</Typography>
				<Button
					className="blue-button"
					type="button"
					variant="contained"
					onClick={logout}
				>
					Logout
				</Button>
			</Paper>
		</Box>
	);
};

export default Logout;
